// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__23iai","header":"ReportDetails_header__Kox4R","title":"ReportDetails_title__1eLM9","left":"ReportDetails_left__1vtUd"};